import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_PROJECT_ID,
  FIREBASE_SENDER_ID,
  FIREBASE_STORAGE_BUCKET
} from '@/constants/env'

const apiKey = FIREBASE_API_KEY
const authDomain = FIREBASE_AUTH_DOMAIN
const projectId = FIREBASE_PROJECT_ID
const storageBucket = FIREBASE_STORAGE_BUCKET
const messagingSenderId = FIREBASE_SENDER_ID
const appId = FIREBASE_APP_ID
const measurementId = FIREBASE_MEASUREMENT_ID

export const firebaseConfig = {
  apiKey,
  authDomain,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
  measurementId
}
